<mat-toolbar mat-dialog-title color="primary-lighter">{{ title|trans }}</mat-toolbar>

<div mat-dialog-content [innerHTML]="message|safe">
</div>

<div mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close] color="warn">{{ cancelText|trans }}</button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary">{{ confirmText|trans }}</button>
</div>
